import translationsModels from 'locales/pl/models/userAgree';

export enum Types {
    Regulations = 'regulations',
    Marketing = 'marketing',
}

export default interface UserAgree {
    value: boolean;
    content: string;
    type: string;
}


export const typesOptions = [{
    type: Types.Regulations,
    label: translationsModels?.userAgree?.type?.regulations?.label,
    content: translationsModels?.userAgree?.type?.regulations?.content,
}, {
    type: Types.Marketing,
    label: translationsModels?.userAgree?.type?.marketing?.label,
    content: translationsModels?.userAgree?.type?.marketing?.content,
}];